module.exports = __webpack_public_path__ + "static/01429fd778fa8200fdb4758313bebdc24505ed636283e612cde19f6bbf415efc-766d5310b7495b2d27072ecdaa10da32.png";